import Axios from "@/plugins/Axios";

export class AppConfigurationService {
  async getNotifiqLancamentoStatus() {
    const response = await Axios().get("app-configurations/notifiq-lancamento-status");
    return response.data;
  }
}

export default new AppConfigurationService();
